/***
 * @Author: ZhaoG
 * @Date: 2025-04-23 15:52:22
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-05-08 17:40:14
 * @FilePath: \gcp-fe\src\app\shop\api\shopping.js
 * @Description: API
 */
import request from "@/config/utils/request";
import { addUrlPerFix } from "@/basa/utils";

//宣传海报
export function queryLscpPortalList(data) {
  return request({
    url: "/apis/jrw/common/users/signup/queryLscpPortalList",
    method: "post",
    data
  });
}

// 首页查询公告列表    /apis/jrw/common/users/signup/qryNoticeTopList
export function qryNoticeTopList(data) {
  return request({
    url: "/apis/jrw/common/users/signup/qryNoticeTopList",
    method: "post",
    data
  });
}

// 查询最新采购公告   /apis/jrw/common/users/signup/qryNoticePageList
export function qryNoticePageList(data) {
  return request({
    url: "/apis/jrw/common/users/signup/qryNoticePageList",
    method: "post",
    data
  });
}

//OAuth2.0
export function OAuth(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_BASEP_URL) +
      "/apis/basap/esi/login/iccec ",
    method: "post",
    data
  });
}

//外部系统获取商旅登录地址
export function getBusiTravelUrl(data) {
  return request({
    url: "/apis/jrw/getBusiTravelUrl",
    method: "post",
    data
  });
}

//通知公告
export function queryPublishedNoticeList(data) {
  return request({
    url: "/apis/jrw/spcms/users/signup/cmc/noticeInfo/queryPublishedNoticeList",
    method: "post",
    data
  });
}

// 右侧悬浮购物车数量
export function cartNum(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_EMP_URL) +
      "/apis/ccem/emc/users/signup/cartNum",
    method: "post",
    data
  });
}

// 右侧悬 发布需求
export function showFlag(data) {
  return request({
    url: addUrlPerFix(process.env.VUE_APP_EMP_URL) + "/apis/ccem/spc/showFlag",
    method: "post",
    data
  });
}
// 频道
export function qrySubTypeInfoList(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_BASE_URL) +
      "/apis/jrw/common/users/signup/qrySubTypeInfoList",
    method: "post",
    data
  });
}
// 通知
export function qryNoticeInfoPageList(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_BASE_URL) +
      "/apis/jrw/common/users/signup/qryNoticeInfoPageList",
    method: "post",
    data
  });
}
// 海报
export function qryAdvInfoList(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_BASE_URL) +
      "/apis/jrw/common/users/signup/qryAdvInfoList",
    method: "post",
    data
  });
}
// 通知详情
export function qryNoticeInfoDetails(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_BASE_URL) +
      "/apis/jrw/common/users/signup/qryNoticeInfoDetails",
    method: "post",
    data
  });
}
// 通知点击量
export function updateNoticeHits(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_BASE_URL) +
      "/apis/jrw/common/users/signup/updateNoticeHits",
    method: "post",
    data
  });
}
// 海报点击量
export function updateAdvHits(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_BASE_URL) +
      "/apis/jrw/common/users/signup/updateAdvHits",
    method: "post",
    data
  });
}

export function encBlackList(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_SCP_URL) + "/apis/scp/bidc/encBlackList",
    method: "post",
    data
  });
}

export function querySupJoinFlag(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_CRMSA_URL) +
      "/apis/bid-scp/bidc/querySupJoinFlag",
    method: "post",
    data
  });
}

export function qryNoticeDetail(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_SCP_URL) +
      "/apis/scp/bidc/users/signup/qryNoticeDetail",
    method: "post",
    data
  });
}

//查询包件信息
export function queryProcessSchemeMatDetail(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_SCP_URL) +
      "/apis/scp/bidc/users/signup/queryProcessSchemeMatDetail",
    method: "post",
    data
  });
}

//相关公告列表查询
export function qryRelatedNoticeList(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_SCP_URL) +
      "/apis/scp/bidc/users/signup/qryRelatedNoticeList",
    method: "post",
    data
  });
}

//取回密码提交
export function dealSupplierFindPwd(data) {
  return request({
    url: "/apis/jrw/smc/users/signup/dealSupplierFindPwd",
    method: "post",
    data
  });
}

/**
 * 检查供应商名称是否可用
 * @param {Object} data - 包含供应商名称等信息的数据对象
 * @returns {Promise} 返回一个Promise对象，包含服务器响应结果
 */
export function checkSuppilerName(data) {
  // 发送POST请求到服务器验证供应商名称
  return request({
    url: "/apis/jrw/smc/users/signup/checkSuppilerName",
    method: "post",
    data
  });
}

// 新增接口
export function add(obj) {
  return request({
    url: `${addUrlPerFix(
      process.env.VUE_APP_BASEP_URL
    )}/apis/basap/users/signup/tijiao`,
    method: "post",
    data: obj
  });
}
// 发送验证码
export function send(obj) {
  return request({
    url: `${addUrlPerFix(
      process.env.VUE_APP_BASEP_URL
    )}/apis/basap/users/signup/send`,
    method: "post",
    data: obj
  });
}

// 获取图行验证码
export function getImageVerifyCode(obj) {
  return request({
    url: `/apis/jrw/appeal/users/signup/getImageVerifyCode`,
    method: "get",
    data: obj
  });
}

// 提交申诉申请
export function dealSubSupBlackAppealInfo(obj) {
  return request({
    url: `/apis/jrw/appeal/users/signup/dealSubSupBlackAppealInfo`,
    method: "post",
    data: obj
  });
}

// 发送验证码
export function sendAppealInfoVerificationCode(obj) {
  return request({
    url: `/apis/jrw/appeal/users/signup/sendAppealInfoVerificationCode`,
    method: "post",
    data: obj
  });
}

// 获取管控范围
export function querySubSupBlackAppealInfoBySubconNameForSup(obj) {
  return request({
    url: `/apis/jrw/appeal/users/signup/querySubSupBlackAppealInfoBySubconNameForSup`,
    method: "post",
    data: obj
  });
}

// 获取管控范围new
export function querySubconControlAppealUnitList(obj) {
  return request({
    url: `/apis/jrw/appeal/users/signup/querySubconControlAppealUnitList`,
    method: "post",
    data: obj
  });
}

// 首页查询综合数据概览    /apis/jrw/common/users/signup/qryComprehensiveDataOverview
export function qryComprehensiveDataOverview(data) {
  return request({
    url: "/apis/jrw/common/users/signup/qryComprehensiveDataOverview",
    method: "post",
    data
  });
}

//轮播图点击量统计
export function updateHits(data) {
  return request({
    url: "/apis/pp/spcms/users/signup/cmc/pubcontent/updateHits",
    method: "post",
    data
  });
}

//获取邮箱验证码
export function checkSendEmailCode(data) {
  return request({
    url: "/apis/jrw/scmc/users/signup/checkSendEmailCode",
    method: "post",
    data
  });
}
//获取邮箱验证码
export function checkEmailVerificationCode(data) {
  return request({
    url: "/apis/jrw/scmc/users/signup/checkEmailVerificationCode",
    method: "post",
    data
  });
}
